import {MenuCampaignMaster} from "../MASTER/Apollo_MasterModel"

export type ApolloAccount = {
  accountgroupId: number,
  accountgroupName: string,
  accountId: number,
  accountName: string,
  advertiserName: string,
  trackerId: string,
  budgetAmount: number,
  status: number,
  approval: number,
  createdAt: string,
  modifiedAt: string,
  modifiedBy: string,
  url: string,
  targetingFlg: number,
  productId: number,
  productName: string,
  industoryName: string,
  d2cOperationFlg: number,
}

export interface Platform {
  platformAccountId: number
  platformAccountName: string
  platformId: number
  platformName: string
  imageUrl: string
}

export type PlatformAccount = {
  accountId: number,
  accountName: string,
  menuId: number,
  menuName: string,
  campaignKindId: number,
  campaignName: string,
  campaignKindName: string,
  platformId: number,
  platformName: string,
  platformAccountId: string,
  accountgroupId: number,
  accountgroupName: string,
  useStatus: number,
  message: string,
  imageUrl: string,
}

export type SubBudgetLimit = {
  deliveryType: number,
  budgetLimit: number,
}

export type ZeusAccountDetail = {
  id: number,
  name: string,
  url: string,
  status: number,
  billingCompanyId: number,
  commonAccountId: number,
  budgetLimit: number,
  subBudgetLimit?: SubBudgetLimit[],
  subBudgetLimitNextMonth?: SubBudgetLimit[],
  subBudgetLowerLimitCurrentMonth?: SubBudgetLimit[],
  advertiserName: string,
  lastUpdateUserId: number,
  lastUpdateUserName: string,
  isApproval: boolean,
  industryId: number,
  createdAt: string,
  updatedAt: string,
}

export type ZeusCampaign = {
  id: number,
  name: string,
  status: number,
  startDate: string,
  endDate: string,
  createdAt: string,
  updateAt: string,
  apolloCampaignId: number,
}

export type ApolloName = {
  accountName: string,
  advertiserName: string,
}

export type AccountGroup = {
  accountgroupId: number,
  accountgroupName: string,
  platforms: Platform[],
  status: number,
  billingId: number,
  billingName: string,
  creditLimitAmount: number, 
  customSegmentFlg: number,
  geoSegmentFlg: number,
  createdAt: string,
  createdBy: string,
  modifiedAt: string,
  modifiedBy: string,
}

export type AccountGroupRequest = {
  accountgroupName: string,
  billingId: string,
  customSegmentFlg: string,
  geoSegmentFlg: string,
}

export type User = {
  userId: number,
  mailaddress: string,
  familyName: string,
  firstName: string,
  organization: string,
  roleNames: string,
}

export type MenuSeletedData = {
  menuId: number,
  campaignKindId: number,
  isSelected: number,
}
export type MenuUseData = {
  menuId: string,
  campaignKindId: string,
  useStatus: string,
}

export type Account = {
  accountId: number,
  accountName: string,
  advertiserName: string,
  status: number,
  approval: number,
  productId: number,
  url: string,
  targetingFlg: number,
  platformAccounts: PlatformAccountData[],
  budgetId: number,
  budgetAmount: number,
  productName: string,
  industoryId: number,
  industoryName: string,
  menus: MenuSeletedData[],
  useMenus: MenuUseData[],
  d2cOperationFlg: number
}

export type AccountForTrackerIdMigration = {
  accountId: number,
  accountName: string,
  advertiserName: string,
  status: number,
  approval: number,
  productId: number,
  url: string,
  targetingFlg: number,
  platformAccounts: PlatformAccountData[],
  budgetId: number,
  budgetAmount: number,
  productName: string,
  industoryId: number,
  industoryName: string,
  menus: MenuSeletedData[],
  useMenus: MenuUseData[],
  d2cOperationFlg: number,
  trackerIdMigrationAccountId: number,
}

export type TrackerIdMigrationSourceAccountInfo = {
  accountgroupId: number,
  accountgroupName: string,
  accountId: number,
  accountName: string,
  type: number,
}

export type PlatformAccountData = {
  platformId: number,
  id: string,
}

// export function isEnablePlatform(platformAccount: PlatformAccountData, platforms: Platform[]) {
//   if (!platforms) return false;
//   const ids: number[] = [];
//   platforms.map(function (platform) {
//     ids.push(platform.platformId);
//   });
//   return ids.indexOf(Number(platformAccount.platformId)) !== -1;
// }
export function isEnablePlatform(useMenus: MenuUseData[] , menuMater: MenuCampaignMaster) {
  return GetMenuStatus(useMenus , menuMater) === "〇" ? true : false;
}

export function GetMenuStatus(useMenus: MenuUseData[] , menuMater: MenuCampaignMaster) {
  if (!useMenus) return false;
  var useData = 0;
  useMenus.map((data) => {
    if (menuMater.menuId === Number(data.menuId)) {
      useData = Number(data.useStatus);
    }
  });
  var state = "‐";
  if (useData) {
    switch(useData) {
      case 1:
        state = "〇"
        break;
      case 2:
      case 3:
      case 4:
      case 5:
        state = "×"
      }
  }
  return state;
}

// メニュー選択状況
export type MenuSelectInfo = {
  menuId: number,
  menuName: string,
  campaignKindId: number,
  campaignKindName: string,
  budgetAmountFlg: number,
  accountCheckFlg: number,
  checked: boolean,
}

export type ApolloAccountApprove = {
  accountgroupId: number,
  accountgroupName: string,
  accountId: number,
  accountName: string,
  advertiserName: string,
  trackerId: string,
  status: number,
  requestAt: string,
  requestBy: string,
  approval: number,
  creditLimitAmount: number,
  budgetAmount: number,
}

export type ApolloAccountApproveRequest = {
  accountId: number[],
  approval: string,
}

export type AccountPlatform = {
  accountId: number,
  menuId: number,
  campaignKindId: number,
  useStatus: number,
  message: string,
  createdAt: string,
  createdBy: string,
  modifiedAt: string,
  modifiedBy: string,
}

